import React from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

const FileSelectorRow = (props: IContentLoaderProps) => {
  return (
    <ContentLoader
      className="file-selctor-row-ph"
      viewBox="0 0 398 66"
      backgroundColor="#e7f1fc"
      foregroundColor="#ffffff"
      {...props}
    >
      <rect x="0" y="16" rx="4" ry="4" width="40" height="40" />
      <rect x="52" y="16" rx="4" ry="4" width="288" height="20" />
      <rect x="52" y="40" rx="4" ry="4" width="120" height="20" />
      <rect x="352" y="16" rx="4" ry="4" width="20" height="20" />
    </ContentLoader>
  );
};

export default FileSelectorRow;
